export default "__VITE_ASSET__BYanpIYO__"